module.exports = __webpack_public_path__ + "static/media/10_The broken mirror_SO.94cc9d40.txt";